/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ChallengeFooter',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'MenuUI/MsftRectButton', 'MenuUI/ControlFocusManager', 'absolute/stringmanager', 'util/NineSliceButton', 'Managers/ScaleManager'],

	function (PIXI, Absolute, _, MsftButton, MsftRectButton, ControlFocusManager, StringManager, NineSliceButton, ScaleManager) {

		var ChallengeFooter = function (parent, game, config) {
			PIXI.DisplayObjectContainer.call(this);
			this.parentToAdd = parent;
			this.game = game;
			this.config = config;
			this.initBkg();
			parent.addChild(this);
			this.initInfo();
			this.initForceScaleSprite();
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
			this.alpha = 0;
			this.bkgGroup.alpha = 0;
		};

		var ColorConstants = {
			Klondike: {right: "#1b9ecb", left: "#48cffd"},
			Spider: {right: "#9757ce", left: "#d5a4ff"},
			FreeCell: {right: "#d62c29", left: "#ff7070"},
			Pyramid: {right: "#d98a01", left: "#fb9a00"},
			TriPeaks: {right: "#79b31b", left: "#8ac91d"}
		};

		ChallengeFooter.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		ChallengeFooter.prototype.appear = function () {
			var self = this, bkg = this.bkgGroup;
			new TWEEN.Tween({alpha: 0})
				.to({alpha: 1}, 150)
				.easing(TWEEN.Easing.Linear.None)
				.onUpdate(function () {
					self.alpha = this.alpha;
					bkg.alpha = this.alpha;
				})
				.start();
		};

		ChallengeFooter.prototype.destroy = function () {
			this.parentToAdd.removeChild(this);
			this.parentToAdd.removeChild(this.bkgGroup);
			ScaleManager.removeElement(this);
		};

		ChallengeFooter.prototype.initBkg = function () {
			this.bkgGroup = new PIXI.Graphics();
			var bkgGraphics = new PIXI.Graphics();
			var rightHex = ColorConstants[this.config.gameName].right,
				leftHex = ColorConstants[this.config.gameName].left;
			bkgGraphics.beginFill(parseInt(rightHex.replace('#', ''), 16), 1);
			bkgGraphics.drawRect(0, Absolute.Coords.y(546), 10000, 10000);
			bkgGraphics.endFill();
			bkgGraphics.beginFill(parseInt(leftHex.replace('#', ''), 16), 1);
			bkgGraphics.drawRect(0, Absolute.Coords.y(546), Absolute.Coords.x(190), 10000);
			bkgGraphics.endFill();
			this.bkgGroup.addChild(bkgGraphics);
			this.parentToAdd.addChild(this.bkgGroup);
		};

		ChallengeFooter.prototype.initInfo = function () {
			var goalLabel, descriptionLabel, config, textStyle;
			config = this.config;
			textStyle = {
				font: Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff'
			};
			goalLabel = new PIXI.Text(Absolute.StringManager('kickoff.goal'), textStyle);
			descriptionLabel = new PIXI.Text(config.gameDescription, textStyle);
			goalLabel.anchor.set(1, 0);
			descriptionLabel.anchor.set(0, 0);
			goalLabel.position.set(Absolute.Coords.x(178), Absolute.Coords.y(556));
			descriptionLabel.position.set(Absolute.Coords.x(200), Absolute.Coords.y(556));
			this.addChild(goalLabel);
			this.addChild(descriptionLabel);
		};

		ChallengeFooter.prototype.initForceScaleSprite = function () {
			this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
			this.forceScaleSprite.width = Absolute.Coords.x(960);
			this.forceScaleSprite.height = Absolute.Coords.y(590);
			this.forceScaleSprite.alpha = 0;
			this.addChild(this.forceScaleSprite);
		};

		ChallengeFooter.prototype.handleResize = function () {
			if (this.parent) this.updateTransform();
			var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
			this.scale.set(1, 1);
			var initialWidth = this.width, initialHeight = this.height;
			this.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
			this.width = initialWidth * screenScaleX;
			this.height = initialHeight * screenScaleY;
			var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight;
			var tookCare = false;
			if (realWidth > roomWidth) {
				this.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.height = ((initialHeight * screenScaleY) * delta);
				if ((this.height / screenScaleY) > roomHeight) {
					this.height = Absolute.Coords.y(1080);
					var delta = roomHeight / heightToShow;
					this.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.height = Absolute.Coords.y(1080);
				var delta = roomHeight / heightToShow;
				this.width = ((initialWidth * screenScaleX) * delta);
				if ((this.width / screenScaleX) > roomWidth) {
					this.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			this.x = 0;
			this.y = (Absolute.Coords.y(1080)) - (this.height);
			this.bkgGroup.scale.set(this.scale.x, this.scale.y);
			this.bkgGroup.position.set(this.x, this.y);
		};

		return ChallengeFooter;
	});

